<template>
  <div :class="$style.box" @touchmove.prevent>
    <!-- 弹窗部分 -->
    <div :class="$style.content">
      <!-- 内容部分 -->
      <!-- 标题 -->
      <div v-if="title" :class="$style.title">
        <h3>{{ title }}</h3>
        <img :src="`${$cdnUrl}/imperialGlory/dialog-close.png`" @click="$emit('close')" alt="" />
      </div>
      <div :class="$style.main">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" module>
.box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);

  .content {
    width: 280px;
    min-height: 100px;
    border-radius: 2px;
    margin: 200px auto;
    box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.66);
    background: linear-gradient(0deg, #f9d47b, #fef9e3, #f9d47b);
    padding: 2px;
    .title {
      width: 100%;
      height: 30px;
      position: relative;
      > h3 {
        width: 100%;
        line-height: 26px;
        text-align: center;
        font-size: 17px;
        font-family: FZDaBiaoSong-B06S;
        font-weight: 400;
        color: #401b0a;
      }
      > img {
        width: 11px;
        position: absolute;
        right: 10px;
        top: 8px;
      }
    }
    .main {
      width: 276px;
      min-height: 96px;
      background: #361001;
      padding: 12px 14px;
    }
  }
}
</style>